'use client';

import { useParams } from 'next/navigation';
import { Container, Grid } from '@mantine/core';
import { SquareCard } from './SquareCard/SquareCard';

export const SquareCardList = ({ services }: { services: any[] }) => {
  const { lang } = useParams();
  return (
    <>
      <Container my="md">
        <Grid gutter="lg">
          {services.map((service: any) => (
            <Grid.Col
              span={{ base: 12, sm: 4 }}
              // @ts-ignore
              key={service.title[lang] ? service.title[lang] : service.title}
            >
              <SquareCard data={service} />
            </Grid.Col>
          ))}
        </Grid>
      </Container>
    </>
  );
};
